/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";
import {
  formatInboxTime,
  showFormattedDate,
  getTimeFormat,
  getDateFormat,
} from "../../Utils/services.js";
import { calulateDiffDuration } from "../../Utils/date-services.js";
import SelectTimeCategory from "./ClockOutModal/SelectTimeCategory.js";
import { fetchClockStatus } from "../../Actions/Clock/clockDataActions.js";
import styles from "./scss/ClockOutModal.module.scss";

class ClockOutModal extends React.Component {
  constructor(props) {
    super(props);
    const languageData = JSON.parse(localStorage.getItem("languageData"));
    this.state = {
      globalLang:
        languageData && languageData.global ? languageData.global : {},
      currentDate: moment().format(getDateFormat()),
      currentTime: moment().format(getTimeFormat()),
      trackAs: null,
      availableTrackAs: {},
      todayClockHistory: [],
    };
  }

  componentDidMount() {
    document.body.style.overflow = "hidden";

    this.props.fetchClockStatus(this.props.user_id).then((data) => {
      const defaultTrack =
        Object.values(data.data.available_track_as).find(
          (el) => el.is_default,
        ) || null;

      const todayClockHistory = data.data?.today_clock_history || [];

      this.setState({
        availableTrackAs: data.data?.available_track_as,
        trackAs: { label: defaultTrack?.display_name, value: defaultTrack?.id },
        todayClockHistory,
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.clock_action_current !== this.props.clock_action_current) {
      this.props.fetchClockStatus(this.props.user_id).then((data) => {
        const defaultTrack =
          Object.values(data.data.available_track_as).find(
            (el) => el.is_default,
          ) || null;

        const todayClockHistory = data.data?.today_clock_history || [];

        this.setState({
          availableTrackAs: data.data?.available_track_as,
          trackAs: {
            label: defaultTrack?.display_name,
            value: defaultTrack?.id,
          },
          todayClockHistory,
        });
      });
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = "";
  }

  dismissClockOutModal = () => {
    this.props.dismissClockOutModal();
  };

  handleClockAction = () => {
    this.props.handleClockAction({ trackAs: this.state.trackAs?.value });
  };

  handleTrackAsChange = (trackAs) => {
    this.setState({ trackAs });
  };

  diffLabel = (clockIn) => {
    const diff = calulateDiffDuration(clockIn);
    const hours = diff.hours === 1 ? "Hour" : "Hours";
    return `${diff.hours} ${hours} ${diff.minutes}  Min`;
  };

  render() {
    return (
      <div className="clockOut-modal-wrapper">
        <div
          className={
            this.props.isShowClockOutModal ? "modalOverlay" : "no-display"
          }
        >
          <div className="small-popup-outer subscription-popup">
            <div className="small-popup-header p-l-15">
              <div className="popup-name">{this.props.clock_label}</div>
              <a className="small-cross" onClick={this.dismissClockOutModal}>
                ×
              </a>
            </div>
            <div className="small-popup-content clockContent">
              <div className="juvly-container">
                <div className="clockTime">{this.state.currentTime}</div>
                <div className="clockDate">{this.state.currentDate}</div>
                <div className="clockName">Hello, {this.props.user_name}</div>
                {this.props.clock_action_current === "in" &&
                  this.props.clock_in && (
                    <p className="clockDetail">
                      You clocked in on{" "}
                      <span>{showFormattedDate(this.props.clock_in)}</span> at{" "}
                      <span>{formatInboxTime(this.props.clock_in)}</span>
                      {this.props.tracked_as_name && (
                        <>
                          {" "}
                          as <span>{this.props.tracked_as_name}</span>
                        </>
                      )}
                    </p>
                  )}
                {this.props.clock_action_current === "out" &&
                  this.props.clock_out && (
                    <p className="clockDetail">
                      You clocked out on{" "}
                      <span>{showFormattedDate(this.props.clock_out)}</span> at{" "}
                      <span>{formatInboxTime(this.props.clock_out)}</span>
                      {this.props.tracked_as_name && (
                        <>
                          {" "}
                          as <span>{this.props.tracked_as_name}</span>
                        </>
                      )}
                    </p>
                  )}

                {this.props.clock_action_current === "in" && (
                  <div className={styles.clockDetailsContainer}>
                    {this.state.todayClockHistory.map((history) => (
                      <div className="ClockOuter" key={history.id}>
                        <div className="clockSection col-sm-5 col-xs-12 text-left">
                          <span>
                            {history.clock_in
                              ? formatInboxTime(history.clock_in)
                              : "00:00"}
                          </span>
                          <p>Start Time</p>
                        </div>
                        <div className="clockSection col-sm-2 col-xs-12 text-center no-padding">
                          <img alt="" src="/images/clock.png" />
                        </div>
                        <div className="clockSection col-sm-5 col-xs-12 text-right">
                          <span>{this.diffLabel(history.clock_in)}</span>
                          {history.time_tracking_config?.display_name && (
                            <p>{history.time_tracking_config?.display_name}</p>
                          )}
                          <p>Time Duration</p>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {this.props.clock_action_current === "out" && (
                  <SelectTimeCategory
                    value={this.state.trackAs}
                    availableTrackAs={this.state.availableTrackAs}
                    onChange={this.handleTrackAsChange}
                  />
                )}
                <div className="text-center">
                  <a
                    onClick={this.handleClockAction}
                    className="new-blue-btn clockOutBtn"
                  >
                    {this.props.clock_label}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      fetchClockStatus,
    },
    dispatch,
  );
};

export default connect(null, mapDispatchToProps)(withRouter(ClockOutModal));
